import { render } from "./AboutPage.vue?vue&type=template&id=0c1af8cf&scoped=true"
const script = {}

import "./AboutPage.vue?vue&type=style&index=0&id=0c1af8cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1af8cf"]])

export default __exports__